// src/components/operationsAssociate/InventoryStats.jsx
import React from 'react';
import { Package, CheckCircle, AlertTriangle, Layers } from 'lucide-react';
import PremiumStatCard from '../common/PremiumStatCard';

const InventoryStats = ({ items }) => {
    const totalItems = items.length;
    const totalInStock = items.reduce((sum, item) => sum + (item.inStock || 0), 0);
    const lowStockItems = items.filter(item => item.inStock <= item.minStockLevel).length;
    const totalCategories = [...new Set(items.map(item => item.category))].length;

    return (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            <PremiumStatCard 
                title="Total Registry" 
                value={totalItems} 
                icon={<Package className="text-blue-600" />} 
                iconBg="bg-blue-50"
                description="Unique inventory items"
            />
            <PremiumStatCard 
                title="Aggregate Stock" 
                value={totalInStock} 
                icon={<CheckCircle className="text-emerald-600" />} 
                iconBg="bg-emerald-50"
                description="Total unit count"
            />
            <PremiumStatCard 
                title="Depleted SKUs" 
                value={lowStockItems} 
                icon={<AlertTriangle className="text-orange-600" />} 
                iconBg="bg-orange-50"
                description="Below safety threshold"
            />
            <PremiumStatCard 
                title="Categorization" 
                value={totalCategories} 
                icon={<Layers className="text-purple-600" />} 
                iconBg="bg-purple-50"
                description="Resource classifications"
            />
        </div>
    );
};

export default InventoryStats;